// Mirrors app-service utils/user/terms.py company_terms_accepted(): T&C accepted for the company.
// Deliberately not company.terms — that is the GPO fee tier, and 0% is a valid tier.
export function companyAcceptedTerms(
  company: { agreed_to_terms?: unknown; user_agreed?: unknown; agreed_to_terms_date?: unknown } | null | undefined,
): boolean {
  return !!(company?.agreed_to_terms && company?.user_agreed && company?.agreed_to_terms_date);
}

// Pricing / add-to-cart gate: agreed_to_terms only. Older medigi companies uploaded a
// custom terms doc instead of accepting in-app, so they have no user_agreed or
// agreed_to_terms_date. The T&C popup keeps the full predicate.
export function companyAgreedToTerms(
  company: { agreed_to_terms?: unknown } | null | undefined,
): boolean {
  return !!company?.agreed_to_terms;
}
